import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=4011b838&"
import script from "./TutorialVideos.vue?vue&type=script&lang=ts&"
export * from "./TutorialVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4011b838')) {
      api.createRecord('4011b838', component.options)
    } else {
      api.reload('4011b838', component.options)
    }
    module.hot.accept("./TutorialVideos.vue?vue&type=template&id=4011b838&", function () {
      api.rerender('4011b838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/TutorialVideos.vue"
export default component.exports